export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/'; //Uppercase perchè è una costante che non cambierà mai
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'c92216e9-7dd9-43b7-b8b3-87eb5f73e4ad';
export const MODAL_CLOSE_SEC = 2.5;

///////////////////////////////////////

// https://forkify-api.herokuapp.com/v2
